// Registro dos documentos exibidos em /documentacao.
// A fonte de cada doc é um .md canônico em backend/docs (importado como texto no build),
// então o mesmo arquivo serve o painel, o Claude Code e o Apolo.
import snippetPaginas from "../../../../docs/SNIPPET-PAGINAS.md?raw";
import wppconnectServer from "../../../../docs/WPPCONNECT-SERVER.md?raw";
import apolo from "../../../../docs/APOLO.md?raw";
import metaCoexistencia from "../../../../docs/META-COEXISTENCIA.md?raw";
import appMobile from "../../../../docs/APP-MOBILE.md?raw";
import lastlink from "../../../../docs/LASTLINK.md?raw";
import ladeira from "../../../../docs/LADEIRA.md?raw";

export const DOCS = [
    {
        slug: "snippet-paginas",
        titulo: "Snippet nas páginas",
        categoria: "Tracking",
        descricao: "Padrão para montar páginas de venda, modal, cadastro de lead e vídeo com o tracker do Metriqa. Pronto para enviar a uma IA.",
        arquivo: "docs/SNIPPET-PAGINAS.md",
        conteudo: snippetPaginas,
    },
    {
        slug: "wppconnect-server",
        titulo: "WhatsApp não-oficial (wppconnect)",
        categoria: "WhatsApp",
        descricao: "Como o wppconnect-server funciona, o que ele grava e o que o Metriqa grava: histórico por sessão, chat, gravação de grupos, LID e procedimentos operacionais.",
        arquivo: "docs/WPPCONNECT-SERVER.md",
        conteudo: wppconnectServer,
    },
    {
        slug: "apolo",
        titulo: "Apolo (bot de avisos + IA)",
        categoria: "WhatsApp",
        descricao: "Como o Apolo funciona: avisos de venda, comandos, memória e skills, jornada do cliente, rotinas diárias e o que ele pode ou não fazer.",
        arquivo: "docs/APOLO.md",
        conteudo: apolo,
    },
    {
        slug: "meta-coexistencia",
        titulo: "API oficial (Meta) e Coexistência",
        categoria: "WhatsApp",
        descricao: "O que é a Cloud API oficial, preço e janela de 24 h, e a opção Coexistência: mesmo número no app do celular e na API, requisitos, limitações e o que falta no Metriqa.",
        arquivo: "docs/META-COEXISTENCIA.md",
        conteudo: metaCoexistencia,
    },
    {
        slug: "app-mobile",
        titulo: "App Android do inbox oficial",
        categoria: "WhatsApp",
        descricao: "O app do celular que acompanha e responde o número oficial: decisões, o que o backend ganhou (Bearer, push), como operar e como lançar uma versão nova do APK.",
        arquivo: "docs/APP-MOBILE.md",
        conteudo: appMobile,
    },
    {
        slug: "lastlink",
        titulo: "Integração Lastlink",
        categoria: "Integrações",
        descricao: "Como ligar o webhook da Lastlink, o que cada evento vira no Metriqa, e como montar o link de checkout com UTMs, sck e o uid do cliente (vtid) para a jornada.",
        arquivo: "docs/LASTLINK.md",
        conteudo: lastlink,
    },
    {
        slug: "ladeira",
        titulo: "Skills do curso Tráfego com IA Pro (ladeira_*)",
        categoria: "Tráfego",
        descricao: "O pacote de skills do Ladeira instalado no Claude Code e no Apolo: o que cada módulo faz, o que muda em relação ao curso (conexão, contas, dados do sync, 1 dia-clique, imposto, escrita só com SIM) e os scripts de apoio.",
        arquivo: "docs/LADEIRA.md",
        conteudo: ladeira,
    },
];

export function findDoc(slug) {
    return DOCS.find((d) => d.slug === slug) || null;
}
